import { createContext } from 'react';

import { Client } from '@suntex.fim/api-client';
import { Locale } from '@suntex.fim/enums';

/**
 * Minimal authenticated HTTP transport. An axios instance configured with
 * `transformResponse: (data) => data` satisfies this shape directly.
 */
export interface Http {
  get(url: string): Promise<{ data: string }>;
  post(url: string, data: unknown): Promise<{ data: string }>;
}

export interface FrameworkContext {
  api: Client;
  calendar: {
    getCurrentSeason(): string;
    getPreviousSeason(): string;
  };
  locale: Locale;
  /**
   * @deprecated Use typed API client methods instead.
   *
   * Raw authenticated HTTP transport. Provided by hosts that render
   * Canvas- or VIF-based classic games. Not available in MFE contexts.
   */
  http: Http;
}

export const FrameworkContext = createContext<FrameworkContext | null>(null);
